import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const PageTitleContext = createContext({
  pageTitle: null,
  setPageTitle: () => {},
});

export function PageTitleProvider({ children }) {
  const [pageTitle, setPageTitleState] = useState(null);
  const setPageTitle = useCallback((next) => {
    setPageTitleState(next || null);
  }, []);

  const value = useMemo(() => ({ pageTitle, setPageTitle }), [pageTitle, setPageTitle]);

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}

/**
 * Sets the last breadcrumb label for the current page. Clears on unmount.
 * Pass a string; ignore null/undefined to leave the route-map fallback.
 */
export function usePageTitle(title) {
  const { setPageTitle } = useContext(PageTitleContext);

  useEffect(() => {
    if (typeof title !== "string" || !title.trim()) {
      return undefined;
    }
    setPageTitle(title);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
}

export function usePageTitleOverride() {
  return useContext(PageTitleContext).pageTitle;
}
